module.exports = __webpack_public_path__ + "static/Ronrico-Logo-ac0d55fe7ce33b988ad25ba490ffb930.png";